<template>
  <div class="p-col-12">
    <div class="card">
      <h5>Email Config</h5>
      <router-link to="/emailconfig/create">
        <Button label="Nuevo" style="width: 10rem" />
      </router-link>
      <DataTable
        :value="items"
        scrollHeight="400px"
        :loading="loading2"
        scrollDirection="both"
        class="p-mt-3"
      >
        <Column field="plantilla.name" header="Plantilla"></Column>
        <Column field="name" header="Name"></Column>
        <Column field="subjectText" header="Subject"></Column>
        <Column field="emailConfirmed" header="Email Confirmado">
          <template #body="{data}">
            <span class="p-column-title">Activo</span>
            <span
              :class="
                'empresa-badge status-' + (data.active ? 'active' : 'inactive')
              "
              >{{ data.active ? 'Activo' : 'No Activo' }}</span
            >
          </template>
        </Column>
        <Column
          header="Acciones"
          :exportable="false"
          :style="{ width: '200px' }"
          bodyClas="p-ml-auto"
        >
          <template #body="{data}">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success p-mr-2"
              @click="edit(data.id)"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-warning p-mr-2"
              @click="borrar(data.id)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import { apiGet, apiDelete } from '../../helpers/rest-api';

export default {
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.getAll();
  },

  methods: {
    getAll() {
      apiGet('emailconfig').then((response) => (this.items = response.data));
    },

    borrar(index) {
      apiDelete('emailconfig/' + index).then(() => this.getAll());
    },

    edit(index) {
      this.$router.push('/emailconfig/edit/' + index);
    },
  },
};
</script>

<style scoped lang="scss">
.cursor {
  cursor: pointer;
}

.empresa-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-active {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-inactive {
    background: #ffcdd2;
    color: #c63737;
  }
}
</style>
